import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Drawer, Popconfirm, Radio,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import UserActions from '@Actions/userActions';
import ExtraChargesActions from '@Actions/configurations/extraChargesAction';
import ExtraChargesForm from './ExtraChargesForm';
import GeneralConfigurationActions from '../../../../actions/configurations/generalConfigurationActions';
import './style.scss';

/**
 *
 */
const ExtraCharges = ({
  user, deleteChargeLoading, updateChargeLoading, getChargesLoading, extraChargesResults, getCharges, deleteCharge, updateCharge, entityType,
  getUserProfile, updateGeneralConfiguration, updateGeneralConfigurationLoading,
}) => {
  const useCustomCharge = (entityType === 'PURCHASE_ORDER') ? user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.use_custom_charges : user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.use_custom_charges;

  const [extraChargesType, setExtraChargesType] = useState(useCustomCharge ? 'Custom Charges' : 'Fixed Charges');
  const [showNewChargeModal, setShowNewChargeModal] = useState(false);
  const [showUpdateChargeModal, setShowUpdateChargeModal] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState([]);
  const configData = (entityType === 'PURCHASE_ORDER') ? user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings : user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings;

  const entityName = (entityType === 'PURCHASE_ORDER') ? 'PURCHASE' : 'SALES';
  const handleRadioChange = (e) => {
    if (e.target.value === 'Fixed Charges') {
      getCharges(user?.tenant_info?.org_id, entityName);
    }
    if (e.target.value === 'Fixed Charges') {
      configData.use_custom_charges = false;
    } else {
      configData.use_custom_charges = true;
    }
    const payload = {
      entity_name: entityType,
      data: configData,
    };
    updateGeneralConfiguration(payload, () => {
      getUserProfile();
      setExtraChargesType(e.target.value);
    });
  };

  useEffect(() => {
    if (extraChargesType === 'Fixed Charges') {
      getCharges(user?.tenant_info?.org_id, entityName);
    }
  }, []);

  const chargesListColumns = [
    {
      title: 'Charge Name',
      render: (text, record) => (
        <Fragment>
          {record?.ledger_name}
        </Fragment>
      ),
    },
    {
      title: 'SAC Code',
      render: (text, record) => (
        <Fragment>
          {record?.charge_sac_code || '-'}
        </Fragment>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            style={{
              cursor: 'pointer',
              opacity: '1',
            }}
            className="roundIconButton"
            onClick={() => {
              setShowUpdateChargeModal(true);
              setSelectedCharge(record);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to delete this charge?"
            onConfirm={() => {
              deleteCharge({ ledger_id: record?.ledger_id }, () => {
                getCharges(user?.tenant_info?.org_id, entityName);
              });
            }}
            okText="Yes"
            cancelText="No"
            disabled={record?.is_system_charge}
          >
            <div
              className="charges_deleteButton"
              style={{ cursor: record?.is_system_charge ? 'not-allowed' : 'pointer' }}
            >
              <DeleteOutlined />
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];
  return (
    <React.Fragment>
      <Radio.Group
        onChange={handleRadioChange}
        value={extraChargesType}
        disabled={user?.tenant_info?.it_id}
      >
        <Radio value="Custom Charges">Custom Extra Charges</Radio>
        <Radio value="Fixed Charges">Standard Extra Charges</Radio>
      </Radio.Group>
      {extraChargesType === 'Fixed Charges' && (
        <Fragment>

          <div className="charges__wrapper">
            <div className="ant-row">
              <div className="ant-col-md-18">
                <div className="charges__table__wrapper">
                  <div className="charges__table__data hide__in-mobile">
                    <Table
                      title={() => (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          {`${extraChargesResults?.length || '0'} ${'Charges'}`}
                          <Fragment>
                            <H3Button
                              buttonType={defaultButtonTypes.BLUE_ROUNDED}
                              text="+ New Charge"
                              onClick={() => setShowNewChargeModal(true)}
                              customClass="charges__header__add-button hide__in-mobile"
                            />
                          </Fragment>
                        </div>
                      )}
                      loading={getChargesLoading || updateChargeLoading || deleteChargeLoading || updateGeneralConfigurationLoading}
                      showHeader
                      size="small"
                      scroll="scroll"
                      columns={chargesListColumns}
                      dataSource={extraChargesResults || []}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Drawer
            open={showNewChargeModal}
            width="360px"
            mask
            onClose={() => setShowNewChargeModal(false)}
            destroyOnClose
          >
            <div className="custom-drawer__header-wrapper">
              <div className="custom-drawer__header" style={{ width: '315px' }}>
                <H3Text text="Add New Charge" className="custom-drawer__title" />
                <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewChargeModal(false)} />
              </div>
            </div>
            <div className="create-po__new-vendor-wrapper">
              <ExtraChargesForm
                callback={() => {
                  getCharges(user?.tenant_info?.org_id, entityName);
                  setShowNewChargeModal(false);
                }}
                entityType={entityType}
              />
            </div>
          </Drawer>
          <Drawer
            title="Update Charge"
            open={showUpdateChargeModal}
            onClose={() => setShowUpdateChargeModal(false)}
            width="360px"
            destroyOnClose
          >
            <div className="custom-drawer__header-wrapper">
              <div className="custom-drawer__header" style={{ width: '315px' }}>
                <H3Text text="Update Charge" className="custom-drawer__title" />
                <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateChargeModal(false)} />
              </div>
            </div>
            <ExtraChargesForm
              selectedChargeUpdate={selectedCharge}
              callback={() => {
                getCharges(user?.tenant_info?.org_id, entityName);
                setShowUpdateChargeModal(false);
              }}
            />
          </Drawer>
        </Fragment>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ExtraChargesReducers, GeneralConfigurationReducers }) => ({
  user: UserReducers.user,
  extraChargesResults: ExtraChargesReducers.extraChargesResults,
  getChargesLoading: ExtraChargesReducers.getChargeLoading,
  updateChargeLoading: ExtraChargesReducers.updateChargeLoading,
  deleteChargeLoading: ExtraChargesReducers.deleteChargeLoading,
  updateGeneralConfigurationLoading: GeneralConfigurationReducers.updateGeneralConfigurationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCharges: (orgId, entityName) => dispatch(ExtraChargesActions.getCharges(orgId, entityName)),
  updateCharge: (payload, callback) => dispatch(ExtraChargesActions.updateCharge(payload, callback)),
  deleteCharge: (payload, callback) => dispatch(ExtraChargesActions.deleteCharge(payload, callback)),
  updateGeneralConfiguration: (payload, callback) => dispatch(GeneralConfigurationActions.updateGeneralConfiguration(payload, callback)),
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExtraCharges));
